import { render, staticRenderFns } from "./Eteraz.vue?vue&type=template&id=740af7ea"
import script from "./Eteraz.vue?vue&type=script&lang=js"
export * from "./Eteraz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports